// PURCHASE
export const ENV = process.env.NODE_ENV;
export const TIME_TO_CANCEL_PIX_INVOICE = 1000 * 60 * 5; // 5mins
export const TIME_TO_UPDATE_PURCHASE_STATUS = 5 * 1000; // 5 segs
export const DEFAULT_RADIUS_DISTANCE = 500;
export const BASE_URL = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;

